function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "31. ATV");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "_31._ATV",
  "data-name": "31. ATV"
}, /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M10,29a3,3,0,1,0,3,3A3,3,0,0,0,10,29Zm0,4a1,1,0,0,1,0-2A1,1,0,0,1,10,33Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M38,29a3,3,0,1,0,3,3A3,3,0,0,0,38,29Zm0,4a1,1,0,0,1,0-2A1,1,0,0,1,38,33Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M47.51,22.16c-.59-1.36-1.25-1.81-5.34-5.9,2-2,.13-6.26-3.5-6.26H38c-.51,0-.22.33-1.11-1.45C36.52,7.8,36.4,8,30,8a1,1,0,0,0,0,2h5.38l.25.49A6,6,0,0,0,32,15.56L29.59,18H15.41c-2.27-2.27-1.66-2-3.41-2a4,4,0,0,0-4-4H1a1,1,0,0,0,0,2H4v2H1a1,1,0,0,0-1,1v5c0,.56-.07.34,4.15,4.56A8,8,0,1,0,17.41,35h13.2C33.88,43.1,46,40.77,46,32a7.86,7.86,0,0,0-.47-2.65,5.92,5.92,0,0,0,2.34-5.88A1,1,0,0,0,47.51,22.16ZM45.07,22H42.5a1.5,1.5,0,0,1-.37-2.95C44.94,21.86,44.88,21.78,45.07,22Zm-8.54-9.71C37.12,13.47,37.26,14,38,14a1,1,0,0,0,.89-1.45c-.3-.61-.32-.55-.22-.55,2.26,0,3,3,1.66,3h-6.2A4,4,0,0,1,36.53,12.29ZM27.61,20l-2,2H19.58l-2.09-2ZM6,14H8a2,2,0,0,1,2,2H6ZM4.17,23.76,2.41,22H5.83A3,3,0,0,1,4.17,23.76ZM10,38a6,6,0,1,1,6-6A6,6,0,0,1,10,38Zm7.93-5a7.77,7.77,0,0,0-.19-3c13.87,0,12.53-.05,12.49.11A8,8,0,0,0,30.06,33ZM38,38a6,6,0,1,1,6-6A6,6,0,0,1,38,38Zm6.61-10.47A8,8,0,0,0,31.1,28H16.92A8,8,0,0,0,10,24a9.56,9.56,0,0,0-4.36,1.23A4.94,4.94,0,0,0,8,21a1,1,0,0,0-1-1H2V18H12.59c2.21,2.21.9.94,5.9,5.72.42.4.27.28,7.58.28.65,0,.22.13,7.34-7h6.68c.77.78.61.34-.07,1a3.51,3.51,0,0,0,2.48,6H46A3.87,3.87,0,0,1,44.61,27.53Z"
}));

var SvgAtv = function SvgAtv(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAtv, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ATV.c2e41b1c.svg";
export { ForwardRef as ReactComponent };